import { ButtonAccent } from "components/Atoms/Button";
import { useInvoiceV2OrLegacy } from "components/ModernOrLegacy/hooks";
import CreateInvoice from "components/ModernOrLegacy/AppCreateInvoice";
import React from "react";

declare const viewModel: server.viewmodel.InvoiceListFrontModel;

const NewInvoice = () => {
  const invoiceV2OrLegacy = useInvoiceV2OrLegacy();

  return <>
    <ButtonAccent
      label={RESX.GeneralLabels.resxNew}
      onClick={() => invoiceV2OrLegacy.displayModernOrLegacy()}
    />

    <CreateInvoice
      modernOrLegacyHook={invoiceV2OrLegacy}
      brands={viewModel.brands}
      bookkeepings={viewModel.bookkeepings}
      qs=""
    />
  </>;
};

export default NewInvoice;
